module.exports = __webpack_public_path__ + "static/media/bridge.8b646180.svg";